import { render } from "./ClinicSection.vue?vue&type=template&id=40e60b44"
import script from "./ClinicSection.vue?vue&type=script&lang=js"
export * from "./ClinicSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__